// extracted by mini-css-extract-plugin
module.exports = {"tagList":"TagList_tagList__3PFUL","tagListItem":"TagList_tagListItem__Q2zNq"};